import React, { useEffect, useState } from 'react';
import FilterDropdown from 'components/pages/collection/filterDropdown';
import useIsMobile from 'hooks/utils/useIsMobile';
import { useRouter } from 'next/router';
import { useFilter } from 'hooks/utils/useFilters';
import getProductsSpecs from 'lib/utils/getProductsSpecs';
import styles from './productsHeader.module.scss';
import SelectedFilters from '../selectedFilters/selectedFilters';
import FilterAndSort from '../filterAndSort/filterAndSort';
import SortDropdown from '../sortDropdown/sortDropdown';

const ProductsHeader = ({ products, filters, resources }) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const useFilterObject = useFilter(products);
  const {
    state: { conditions, sortOption },
    filterState,
    setFilters,
    resetFilters,
    setConditions,
    removeFilter,
    setSortOption,
  } = useFilterObject;
  const [currentPage, setCurrentPage] = useState('');
  const filterKeys = Object.keys(filters);
  const [availableSpecs, setAvailableSpecs] = useState([]);

  const parseUrlFilters = () =>
    Object.keys(router.query).reduce((prev, key) => {
      if (!filterKeys.includes(key)) return prev;
      const values = router.query[key].split(',');
      const newFilters = values.map(val => ({ id: key, value: val }));
      return [...prev, ...newFilters];
    }, []);

  useEffect(() => {
    setConditions(filters);
  }, [filters]);

  useEffect(() => {
    if (!router.isReady) return;
    const nextPage = router.query.slug;
    const querryFilters = parseUrlFilters();
    const urlSortOption = router.query.sortOption;

    if (nextPage !== currentPage) {
      if (urlSortOption) {
        setSortOption(urlSortOption);
      }
      if (querryFilters.length) {
        setFilters(querryFilters);
      } else {
        resetFilters();
      }
      setCurrentPage(nextPage);
    }
  }, [router.query, router.isReady]);

  useEffect(() => {
    setAvailableSpecs(getProductsSpecs(filterState.filteredProducts));
  }, [filterState.filteredProducts]);

  const isOptionActive = option => {
    if (conditions[option.id] === 'OR') return true;
    return availableSpecs.some(spec => spec.type === option.id && spec.value === option.value);
  };

  const deselectDisabledOptions = () => {
    filterState.selectedFilters.forEach(option => {
      if (!isOptionActive(option)) {
        removeFilter(option);
      }
    });
  };

  useEffect(() => {
    deselectDisabledOptions();
  }, [availableSpecs, filterState.selectedFilters]);

  return (
    <>
      <div className={styles.headerDivider} />
      <div className={styles.productsHeader}>
        {filterKeys.map(filter => (
          <FilterDropdown
            key={filter}
            filterName={filter}
            options={filters[filter].options}
            useFilterObject={useFilterObject}
            isOptionActive={isOptionActive}
          />
        ))}
        <div className={styles.sortingSelect}>
          <SortDropdown
            resources={resources}
            sortOption={sortOption}
            setSortOption={setSortOption}
          />
          <span className={styles.psroductsCount}>({filterState.filteredProducts?.length})</span>
        </div>
      </div>
      <div className={styles.bottomDivider} />
      {!isMobile && <SelectedFilters resources={resources} useFilterObject={useFilterObject} />}
      {isMobile && (
        <FilterAndSort
          filters={filters}
          resources={resources}
          isOptionActive={isOptionActive}
          useFilterObject={useFilterObject}
        />
      )}
    </>
  );
};

export default ProductsHeader;
